<template>
  <transition name="slide-fade">
    <div v-if="visible" class="footer-notify" :class="[`footer-notify-${type}`]">
      <div class="footer-notify-content">
        <div class="footer-notify-icon"></div>
        <div class="footer-notify-text">
          <div class="footer-notify-title">{{ title }}</div>
          <a href="javascript:void(0)" class="footer-notify-message" @click="openNotifyPage">{{ message }}</a>
        </div>
        <div class="footer-notify-close" @click="close">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FooterNotify",
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "info",
      validator: value => ["success", "warning", "error", "info"].includes(value)
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  computed: {
    iconClass() {
      const iconMap = {
        success: "el-icon-success",
        warning: "el-icon-warning",
        error: "el-icon-error",
        info: "el-icon-info"
      }
      return iconMap[this.type]
    }
  },
  methods: {
    show() {
      this.visible = true
      this.startTimer()
    },
    close() {
      this.visible = false
      this.clearTimer()
      this.$emit("close")
    },
    startTimer() {
      this.clearTimer()
      this.timer = setTimeout(() => {
        this.close()
      }, this.duration)
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    openNotifyPage() {
      this.$notifyPage.show()
    }
  }
}
</script>

<style scoped>
.footer-notify {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 99999;
  width: 330px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.footer-notify-content {
  display: flex;
  align-items: center;
}

.footer-notify-icon {
  margin-right: 10px;
  font-size: 24px;
}

.footer-notify-text {
  flex-grow: 1;
}

.footer-notify-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.footer-notify-close {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.footer-notify-close:hover {
  opacity: 1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.footer-notify-success {
  border-left: 4px solid #67c23a;
}
.footer-notify-warning {
  border-left: 4px solid #e6a23c;
}
.footer-notify-error {
  border-left: 4px solid #f56c6c;
}
.footer-notify-info {
  border-left: 4px solid #409eff;
}
.footer-notify-message:hover {
  color: #409eff;
}
</style>
